import { createContext, useContext } from 'react';

export interface AdminLayoutPageHeadingContextValue {
  currentPageTitle: string | null;
  isHeaderTitleVisible: boolean;
}

export const AdminLayoutPageHeadingContext = createContext<AdminLayoutPageHeadingContextValue | null>(null);

export const useAdminLayoutPageHeading = () => useContext(AdminLayoutPageHeadingContext);

export default AdminLayoutPageHeadingContext;
